/* k5-cart-nudge: UpCart drawer enhancer. Config comes from window.K5NUDGE (snippets/k5-cart-nudge.liquid). Rebuilt Oct 12 2026 from the pre-Oct-5 inline script. */
(function(){
  if (window.__k5cart) return; window.__k5cart = 1;
  var K5C = window.K5NUDGE || {}; var K5_BASE = K5C.base || '2:15,3:25', K5_SALE = K5C.sale || null;
  var K5_SS = Date.parse(K5C.ss || ''), K5_SE = Date.parse(K5C.se || '');
  var K5_NOW = Date.now(), K5_RAW = (K5_SALE && K5_NOW >= K5_SS && K5_NOW < K5_SE) ? K5_SALE : K5_BASE; // scheduled sale ladder, flips client-side even on cached pages
  var TIERS = K5_RAW.split(',').map(function(t){var p=t.split(':');return {q:+p[0],p:+p[1]};})
    .filter(function(t){return t.q>0&&t.p>0;}).sort(function(a,b){return a.q-b.q;});
  var SHOP_FMT = K5C.fmt || null;
  var CSS = ''
    + '.k5-on .upcart-public-component-product-tile__product-pricing{display:none!important}'
    + '.k5-on .upcart-public-component-product-tile__controls{display:flex;align-items:flex-end;justify-content:space-between;gap:10px}'
    + '.k5-lp{display:flex;flex-direction:column;align-items:flex-end;text-align:right;line-height:1.25;margin-left:auto}'
    + '.k5-lp__tag{font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:rgba(18,18,18,.55);margin-bottom:3px;white-space:nowrap}'
    + '.k5-lp__row{display:flex;align-items:baseline;gap:6px;white-space:nowrap}'
    + '.k5-lp__was{font-size:13px;color:rgba(18,18,18,.45);text-decoration:line-through}'
    + '.k5-lp__now{font-size:15px;font-weight:600;color:#121212}'
    + '.k5-lp__ea{font-size:11px;color:rgba(18,18,18,.55)}'
    + '.k5-ln{margin-top:10px;font-size:13px;font-weight:500;color:#C8102E}'
    + '.k5-stock{margin-top:8px;font-size:12px;color:rgba(18,18,18,.6)}'
    + '.k5-stock--alert{color:#C8102E;font-weight:600}'
    + '.k5-max{opacity:.3!important;cursor:not-allowed!important}'
    + '.k5-sumon .upcart-public-cart-summary{display:none!important}'
    + '.k5-sumrow{display:flex!important;align-items:baseline;gap:8px}'
    + '.k5-sumrow>*{order:2}.k5-sumrow>span:first-child{order:0;margin-right:auto}'
    + '.k5-sumrow>[class*="cartSubtotalValue"]{margin-left:0!important;float:none!important}'
    + '.k5-sumwas{order:1!important;font-size:14px;color:rgba(18,18,18,.45);text-decoration:line-through;font-weight:400}'
    + '.k5-sumsave{order:3!important;font-size:12px;font-weight:700;letter-spacing:.06em;color:#C8102E;text-transform:uppercase}';

  var cart = null, inv = {}, invReq = {}, flash = {}, busy = false, fetchedSig = '', t;

  function fmt(c, d, th, dec){ var x=(Math.round(c)/100).toFixed(d).split('.'); x[0]=x[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return x[0]+(x[1]?dec+x[1]:''); }
  function money(c){
    var f = window.upcartMoneyFormat || SHOP_FMT || '$'+'{'+'{amount}'+'}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), k = m ? m[1] : 'amount';
    var v = ({ amount:fmt(c,2,',','.'), amount_no_decimals:fmt(c,0,',','.'),
      amount_with_comma_separator:fmt(c,2,'.',','), amount_no_decimals_with_comma_separator:fmt(c,0,'.',','),
      amount_with_apostrophe_separator:fmt(c,2,"'",'.'), amount_with_space_separator:fmt(c,2,' ',',') })[k] || fmt(c,2,',','.');
    return f.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g,'');
  }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];}); }
  function units(){ var n=0; (cart&&cart.items||[]).forEach(function(i){ if(!i.gift_card) n+=i.quantity; }); return n; }
  function nextTier(n){ for (var i=0;i<TIERS.length;i++) if (TIERS[i].q>n) return TIERS[i]; return null; }
  function setHTML(el, h){ if (el.__k5 !== h){ el.innerHTML = h; el.__k5 = h; } }
  function ensure(parent, cls, before){
    var el = parent.querySelector(':scope > .'+cls);
    if (!el){ el = document.createElement('div'); el.className = cls; if (before) parent.insertBefore(el, before); else parent.appendChild(el); }
    return el;
  }
  function vidOf(li){ var a = li.querySelector('a[href*="variant="]'); var m = a && a.getAttribute('href').match(/variant=(\d+)/); return m ? m[1] : null; }
  function domSig(root){ return [].map.call(root.querySelectorAll('.upcart-public-cart-item'), function(li){ var i=li.querySelector('input'); return vidOf(li)+':'+(i?i.value:''); }).join('|'); }
  function cartSig(){ return (cart&&cart.items||[]).map(function(i){ return i.variant_id+':'+i.quantity; }).join('|'); }

  function loadInv(item){
    var v = String(item.variant_id);
    if (inv[v] || invReq[v] || item.gift_card) return;
    invReq[v] = 1;
    fetch('/products/'+item.handle+'?variant='+v+'&section_id=k5-inv', {credentials:'same-origin'})
      .then(function(r){ return r.text(); })
      .then(function(tx){ var m = tx.match(/\{[^<]*\}/); if (m){ inv[v] = JSON.parse(m[0]); apply(); } })
      .catch(function(){});
  }

  function decorateLine(li, item, n, nt){
    var info = li.querySelector('.upcart-public-component-product-tile__info');
    var controls = li.querySelector('.upcart-public-component-product-tile__controls');
    if (!info || !controls) return;
    var q = item.quantity, disc = 0, label = '';
    (item.discounts || []).forEach(function(d){ disc += d.amount; if (!label) label = d.title; });
    var pct = item.original_line_price > 0 ? Math.round(disc / item.original_line_price * 100) : 0;
    var unitNow = disc > 0 ? Math.round(item.original_price * (100 - pct) / 100) : item.original_price;
    var meta = inv[String(item.variant_id)] || {};
    var was = Math.max(item.original_price, meta.cap || 0);
    var h = (disc > 0 && label ? '<span class="k5-lp__tag">'+esc(label)+'</span>' : '')
      + '<span class="k5-lp__row">'
      + (was > unitNow ? '<s class="k5-lp__was">'+money(was)+'</s>' : '')
      + '<span class="k5-lp__now">'+money(unitNow)+'</span>'
      + (q > 1 ? '<span class="k5-lp__ea">each</span>' : '')
      + '</span>';
    setHTML(ensure(controls, 'k5-lp'), h);
    if (!li.classList.contains('k5-on')) li.classList.add('k5-on');

    // per-line "add N more" (Cuts places it under each line)
    var ln = info.querySelector(':scope > .k5-ln');
    if (nt && !item.gift_card){
      var k = nt.q - n;
      ln = ln || ensure(info, 'k5-ln');
      setHTML(ln, 'Add '+k+' more to unlock '+nt.p+'% off');
    } else if (ln) ln.remove();

    // stock limit
    var plus = li.querySelector('.upcart-public-component-product-tile__quantity-plus');
    var st = info.querySelector(':scope > .k5-stock');
    var maxed = meta.inv !== null && meta.inv !== undefined && q >= meta.inv;
    if (plus){ if (maxed) plus.classList.add('k5-max'); else plus.classList.remove('k5-max'); }
    if (maxed){
      st = st || ensure(info, 'k5-stock', info.querySelector(':scope > .k5-ln'));
      var alert = flash[String(item.variant_id)] && (Date.now() - flash[String(item.variant_id)] < 8000);
      var cls = 'k5-stock' + (alert ? ' k5-stock--alert' : '');
      if (st.className !== cls) st.className = cls;
      setHTML(st, meta.inv === 1 ? (alert ? 'Only 1 left in stock. It’s already in your cart.' : 'Only 1 left in stock')
                                 : (alert ? 'Only '+meta.inv+' left. All of them are in your cart.' : 'Only '+meta.inv+' left in stock'));
    } else if (st) st.remove();
  }

  function decorateSummary(root){
    var val = root.querySelector('[class*="cartSubtotalValue"]');
    var foot = root.querySelector('.upcart-footer');
    if (!val || !cart) return;
    var row = val.parentElement, save = cart.total_discount || 0;
    var was = row.querySelector(':scope > .k5-sumwas'), pc = row.querySelector(':scope > .k5-sumsave');
    if (save > 0 && cart.original_total_price > 0){
      if (!row.classList.contains('k5-sumrow')) row.classList.add('k5-sumrow');
      if (foot && !foot.classList.contains('k5-sumon')) foot.classList.add('k5-sumon');
      if (!was){ was = document.createElement('span'); was.className = 'k5-sumwas'; row.appendChild(was); }
      if (!pc){ pc = document.createElement('span'); pc.className = 'k5-sumsave'; row.appendChild(pc); }
      setHTML(was, money(cart.original_total_price));
      setHTML(pc, Math.round(save / cart.original_total_price * 100) + '% saved');
    } else {
      if (was) was.remove(); if (pc) pc.remove();
      row.classList.remove('k5-sumrow'); if (foot) foot.classList.remove('k5-sumon');
    }
  }

  function apply(){
    var h = document.getElementById('upCart'), root = h && h.shadowRoot;
    if (!root) return;
    if (!root.querySelector('#k5-nudge-css')){ var s = document.createElement('style'); s.id = 'k5-nudge-css'; s.textContent = CSS; root.appendChild(s); }
    var old = root.querySelector('.k5-nudge'); if (old) old.remove();
    // rewards copy fix
    var rm = root.querySelector('.upcart-public-rewards__message');
    if (rm && /free gift unlocked/i.test(rm.textContent)) rm.innerHTML = '<p>Free shipping unlocked!</p>';
    var sig = domSig(root);
    if (!cart || (sig !== cartSig() && sig !== fetchedSig)) { refresh(sig); if (!cart) return; }
    var n = units(), nt = nextTier(n), used = {};
    [].forEach.call(root.querySelectorAll('.upcart-public-cart-item'), function(li){
      var v = vidOf(li); if (!v) return;
      var idx = used[v] || 0, c = 0, item = null;
      for (var i = 0; i < cart.items.length; i++){ if (String(cart.items[i].variant_id) === v){ if (c === idx){ item = cart.items[i]; break; } c++; } }
      used[v] = idx + 1;
      if (!item) return;
      loadInv(item);
      decorateLine(li, item, n, nt);
    });
    decorateSummary(root);
  }

  function refresh(sig){
    if (busy) return; busy = true; fetchedSig = sig || '';
    fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); })
      .then(function(c){ cart = c; }).catch(function(){})
      .then(function(){ busy = false; apply(); });
  }
  function soon(){ clearTimeout(t); t = setTimeout(apply, 120); }

  // Surface failed adds (UpCart swallows "maximum quantity already in your cart").
  var of = window.fetch;
  window.fetch = function(input, init){
    var p = of.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)/.test(url)){
        var body = init && init.body;
        p.then(function(r){
          if (r.status === 422){
            var vid = null;
            try { var j = typeof body === 'string' ? JSON.parse(body) : null;
                  if (j){ vid = j.id || (j.items && j.items[0] && j.items[0].id);
                          if (!vid && j.line && cart) vid = cart.items[j.line-1] && cart.items[j.line-1].variant_id; } }
            catch(e){ if (body && body.get) vid = body.get('id'); }
            if (vid) flash[String(vid).split(':')[0]] = Date.now();
            else (cart && cart.items || []).forEach(function(i){ flash[String(i.variant_id)] = Date.now(); });
            setTimeout(apply, 400); setTimeout(apply, 1500); setTimeout(apply, 8200);
          } else if (r.ok) { cart = null; setTimeout(apply, 300); }
        }).catch(function(){});
      }
    } catch(e){}
    return p;
  };

  function watch(){
    var h = document.getElementById('upCart');
    if (!h || !h.shadowRoot) return setTimeout(watch, 800);
    var root = h.shadowRoot;
    // "+" at the stock limit: block the click and explain instead of silently doing nothing
    root.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('.upcart-public-component-product-tile__quantity-plus.k5-max');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var li = b.closest('.upcart-public-cart-item'), v = li && vidOf(li);
      if (v){ flash[v] = Date.now(); apply(); setTimeout(apply, 8200); }
    }, true);
    new MutationObserver(function(ms){
      for (var i = 0; i < ms.length; i++){
        var tg = ms[i].target.nodeType === 3 ? ms[i].target.parentNode : ms[i].target;
        if (tg && tg.closest && tg.closest('[class^="k5-"],#k5-nudge-css')) continue;
        return soon();
      }
    }).observe(root, {childList:true, subtree:true, characterData:true});
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
